<template>
  <div class="my_select_time">
    <el-date-picker
      prefix-icon="no_icon"
      :type="'datetime'"
      :value-format="'yyyy-MM-dd HH:mm:ss'"
      :placeholder="'开始日期'"
      style="width:136px;font-size:12px"
      class="time1"
      size="small"
      :picker-options="pickerOptionsStart()"
      v-model="startTime"
      :clearable="false"
      :default-time="'00:00:00'"
    >
    </el-date-picker>
    <div class="time_to_text" style="color: #666666">~</div>
    <el-date-picker
      prefix-icon="no_icon"
      :type="'datetime'"
      :value-format="'yyyy-MM-dd HH:mm:ss'"
      style="width: 150px;font-size: 12px"
      class="time2"
      :placeholder="'结束日期'"
      size="small"
      :picker-options="pickerOptionsEnd()"
      v-model="endTime"
      :clearable="false"
      :default-time="'23:59:59'"
    >
    </el-date-picker>
    <i class="el-icon-circle-close date_icon1" @click="clearTime()"></i>
    <img src="@/assets/images/select_date.svg" alt="" class="date_icon2" />
  </div>
</template>

<script>
export default {
  name: 'dateRange',
  props: {
    startValue: {
      type: String,
      default: ''
    },
    endValue: {
      type: String,
      default: ''
    }
  },
  watch: {
    startTime: {
      handler(newValue, oldValue) {
        this.$emit('update:startValue', newValue)
      },
      deep: true
    },
    endTime: {
      handler(newValue, oldValue) {
        this.$emit('update:endValue', newValue)
      },
      deep: true
    },
    startValue: {
      handler(newValue, oldValue) {
        if (newValue!=null) {
          this.startTime = this.startValue;
        }
      }
    },
    endValue: {
      handler(newValue, oldValue) {
        if (newValue!=null) {
          this.endTime = this.endValue
        }
      }
    }
  },
  data() {
    return {
      startTime: '',
      endTime: ''
    }
  },
  mounted() {
    this.startTime = this.startValue;
    this.endTime = this.endValue;
  },
  methods: {
     pickerOptionsStart() {
      return {
        disabledDate: (time) => {
            if (this.endTime) {
              var flag = false;
              flag =  time.getTime() > new Date(this.endTime).getTime();
              return flag;
            }
        },
      }
    },
    pickerOptionsEnd() {
      return {
         disabledDate: (time) => {
            if (this.startTime) {
              var flag = false;
              return time.getTime() < new Date(this.startTime).getTime()
            }
        },
      }
    },
    clearTime() {
      this.startTime = '';
      this.endTime = '';
    }
  }
}
</script>

<style scoped lang="scss">
.my_select_time {
  position: relative;
  display: inline-block;

  .time_to_text {
    display: inline-block;
    font-size: 14px;
    padding: 0px !important;
    height: 32px;
    line-height: 32px;
    border-top: 1px solid #b7bcc6;
    color: #666666;
    margin-top: 0px !important;
    border-bottom: 1px solid #b7bcc6;
    vertical-align: bottom;
    text-align: center;
    width: 14px;
  }

  .to_text_disabled {
    background: #f5f7fa;
    cursor: not-allowed;
  }

  .time1 {
    width: 110px;
    /deep/.el-input__inner {
      font-size: 13px;
      padding: 0 0px 0 7px!important;
      border-right: 0px;
      border-radius:6px;
      border-top-right-radius: 0px;
      border-bottom-right-radius: 0px;
      @media screen and(max-width:1440px){
        font-size: 12px;
      }
    }
  }

  .time2 {
    width: 155px;
    /deep/.el-input__inner {
      font-size: 13px;
      border-left: 0px;
      border-radius:6px;
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
      padding: 0 20px 0 4px !important;
      @media screen and(max-width:1440px){
        font-size: 12px;
      }
    }
  }

  .date_icon2,
  .date_icon1 {
    position: absolute;
    right: 5px;
    height: 32px;
    line-height: 32px;
    width: 16px;
    font-size: 16px;
  }

  .date_icon1 {
    display: none;
    cursor: pointer;
  }
}
.my_select_time:hover {
  .date_icon2 {
    display: none;
  }

  .date_icon1 {
    display: inline-block;
  }
}
</style>